import { ConversationsListStatus } from '@app/hooks'
import { hasRole, UserState } from '@app/store/user'

export const spamStatuses = (
  userState: UserState
): ConversationsListStatus[] =>
  hasRole(userState)('Staff')
    ? ['dispatchedAndSpam', 'spam']
    : ['dispatchedAndSpam']
